import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from '@systemeio/icons';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
interface InputWithSelectsProps {
  className?: string;
  endSelect?: ReactNode;
  input: ReactNode;
  startSelect?: ReactNode;
}
type InputWithSelectsTriggerProps = ComponentPropsWithoutRef<'button'> & {
  side: 'start' | 'end';
  size?: 'sm' | 'md';
};
function InputWithSelects(t0) {
  const $ = _c(9);
  const {
    className,
    endSelect,
    input,
    startSelect
  } = t0;
  const t1 = startSelect && "[&_[data-slot=input-group]]:rounded-l-none [&_input]:rounded-l-none";
  const t2 = endSelect && "[&_[data-slot=input-group]]:rounded-r-none [&_input]:rounded-r-none";
  let t3;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2) {
    t3 = twMerge("flex items-end", t1, t2, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== endSelect || $[5] !== input || $[6] !== startSelect || $[7] !== t3) {
    t4 = <div className={t3}>{startSelect}{input}{endSelect}</div>;
    $[4] = endSelect;
    $[5] = input;
    $[6] = startSelect;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function InputWithSelectsTrigger(t0) {
  const $ = _c(17);
  let children;
  let className;
  let props;
  let side;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      className,
      side,
      size: t1,
      type: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = side;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    side = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const size = t1 === undefined ? "md" : t1;
  const type = t2 === undefined ? "button" : t2;
  const t3 = side === "start" ? "rounded-l-md border-r-0" : "rounded-r-md border-l-0";
  const t4 = size === "sm" ? "h-8" : "h-10";
  let t5;
  if ($[7] !== className || $[8] !== t3 || $[9] !== t4) {
    t5 = twMerge("focus-visible:focus-ring-primary border-field-border bg-field-bg-secondary transition-base hover:bg-bg-tertiary disabled:bg-field-bg-disabled disabled:text-text-disabled flex items-center gap-2.5 border px-3 text-base outline-none data-popup-open:[&_svg]:rotate-180", t3, t4, className);
    $[7] = className;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronDownIcon className="text-icon-primary transition-base size-5" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children || $[13] !== props || $[14] !== t5 || $[15] !== type) {
    t7 = <button {...props} className={t5} type={type}>{children}{t6}</button>;
    $[12] = children;
    $[13] = props;
    $[14] = t5;
    $[15] = type;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export { InputWithSelects, InputWithSelectsTrigger };
export type { InputWithSelectsProps, InputWithSelectsTriggerProps };